import HomeIcon from '@mui/icons-material/Home';
import PublicIcon from '@mui/icons-material/Public';
import Avatar from '@mui/material/Avatar';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import { useLocation, useNavigate } from 'react-router-dom';

const NAV_ITEMS = [
  { label: 'ホーム', path: '/dashboard', icon: HomeIcon },
  { label: 'タイムライン', path: '/timeline', icon: PublicIcon },
  { label: 'プロフィール', path: '/profile', icon: null },
];

export const BOTTOM_NAV_HEIGHT = 64;

export function BottomNav({ profileImageURL }) {
  const navigate = useNavigate();
  const location = useLocation();

  const currentIndex = NAV_ITEMS.findIndex((item) => item.path === location.pathname);
  const isProfileSelected = location.pathname === '/profile';

  return (
    <Paper
      elevation={0}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
        borderRadius: 0,
        borderTop: '1px solid rgba(255,255,255,0.06)',
        bgcolor: '#0A0A0F',
      }}
    >
      <BottomNavigation
        value={currentIndex === -1 ? 0 : currentIndex}
        onChange={(_, newValue) => navigate(NAV_ITEMS[newValue].path)}
        sx={{
          bgcolor: 'transparent',
          height: BOTTOM_NAV_HEIGHT,
          '& .MuiBottomNavigationAction-root': {
            color: 'rgba(255,255,255,0.35)',
            minWidth: 0,
            padding: '6px 0',
            '&.Mui-selected': {
              color: '#FFD700',
            },
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.6rem',
            '&.Mui-selected': {
              fontSize: '0.6rem',
            },
          },
        }}
      >
        {NAV_ITEMS.map(({ label, icon: Icon }) => (
          <BottomNavigationAction
            key={label}
            label={label}
            icon={
              Icon ? (
                <Icon sx={{ fontSize: 22 }} />
              ) : (
                <Avatar
                  src={profileImageURL}
                  sx={{
                    width: 22,
                    height: 22,
                    border: isProfileSelected ? '1.5px solid #FFD700' : '1.5px solid transparent',
                  }}
                />
              )
            }
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
}
